module.exports = __webpack_public_path__ + "img/plus.8aea8b65.svg";